export const TUTORIAL_VIRTUAL_STUDENT_ID = 'tutorial-virtual';

export function isTutorialVirtualStudent(id?: string | number | null) {
	return String(id || '') === TUTORIAL_VIRTUAL_STUDENT_ID;
}

export const TUTORIAL_VIRTUAL_STUDENT = {
	id: TUTORIAL_VIRTUAL_STUDENT_ID,
	name: 'Hà Anh',
	full_name: 'Hà Anh',
	age: '28 tháng tuổi',
	learning_time: 'Đã học 5 tháng',
	profile_photo: {
		default: {
			color: '#E5A42B',
			initial: 'H',
		},
	},
};

export const TUTORIAL_VIRTUAL_PLAN = {
	id: 'tutorial-plan-1',
	order: 1,
	apply_date: '2021-04-01',
	applied_at: '2021-04-01',
	sent_at: null,
	monthly_report: {
		state: 'in_progress',
	},
};

export const TUTORIAL_VIRTUAL_PLAN_STATS = {
	goals_count: 0,
	skills_count: 0,
	continued_goals_count: 0,
	new_goals_count: 0,
	goals_from_lib_count: 0,
	goals_from_stopped_count: 0,
};

export const TUTORIAL_VIRTUAL_PLAN_ROW = {
	student: {
		...TUTORIAL_VIRTUAL_STUDENT,
		has_parent: false,
	},
	active_plan: null,
	scheduled_plan: null,
	active_plan_goal_count: 0,
	pending_plan_goal_count: 0,
	library_count: 0,
	completed_goals_count: 0,
};

export const TUTORIAL_VIRTUAL_LIBRARIES = [
	{
		ids: [101],
		name: 'Chương trình Giáo dục mầm non',
		skill_count: 4,
		goal_count: 11,
		display_age_range: '9 tháng - 7 tuổi',
	},
	{
		ids: [102],
		name: 'Chương trình Ngôn ngữ và kỹ năng xã hội (VB)',
		skill_count: 6,
		goal_count: 12,
		display_age_range: '18 tháng',
	},
	{
		ids: [103],
		name: 'Chương trình Can thiệp sớm Denver',
		skill_count: 4,
		goal_count: 10,
		display_age_range: '9 tháng',
	},
	{
		ids: [104],
		name: 'Chương trình Từng bước nhỏ',
		skill_count: 6,
		goal_count: 12,
		display_age_range: '18 tháng',
	},
	{
		ids: [105],
		name: 'Chương trình Kỹ năng ngôn ngữ và học tập cơ bản (AB)',
		skill_count: 4,
		goal_count: 12,
		display_age_range: '9 tháng',
	},
];

export const TUTORIAL_VIRTUAL_GOAL_LIBRARY = {
	name: 'Chương trình Kỹ năng ngôn ngữ và học tập cơ bản (AB)',
	description:
		'Xác định mốc phát triển tương ứng & mức độ ưu tiên của từng lĩnh vực nhằm thiết lập mục tiêu can thiệp cá nhân hoá phù hợp với năng lực hiện tại của trẻ.',
};

export const TUTORIAL_VIRTUAL_SKILLS = [
	{
		id: 1,
		name: 'Vận động tinh',
		priority_level: 5,
		selected_option: 0,
		age_ranges: [{ display_age: '26 - 38 tháng tuổi', id: 1 }],
	},
	{
		id: 2,
		name: 'Vận động thô',
		priority_level: 5,
		selected_option: 0,
		age_ranges: [{ display_age: '26 - 38 tháng tuổi', id: 2 }],
	},
	{
		id: 3,
		name: 'Hành vi và giác quan',
		priority_level: 5,
		selected_option: 0,
		age_ranges: [{ display_age: '26 - 38 tháng tuổi', id: 3 }],
	},
	{
		id: 4,
		name: 'Hợp tác khen thưởng',
		priority_level: 5,
		selected_option: 0,
		age_ranges: [{ display_age: '26 - 38 tháng tuổi', id: 4 }],
	},
	{
		id: 5,
		name: 'Khả năng quan sát',
		priority_level: 5,
		selected_option: 0,
		age_ranges: [{ display_age: '26 - 38 tháng tuổi', id: 5 }],
	},
	{
		id: 6,
		name: 'Giao tiếp',
		priority_level: 5,
		selected_option: 0,
		age_ranges: [{ display_age: '26 - 38 tháng tuổi', id: 6 }],
	},
];

export const TUTORIAL_VIRTUAL_LIBRARY_CREATE = [
	{
		id: 1,
		name: 'Vận động tinh',
		item_count: 3,
		library_items: [
			{
				id: 11,
				name: '[Z1] Trẻ có thể dùng bút sáp vẽ lên giấy',
				selected: true,
				sub_item_count: 0,
			},
			{
				id: 12,
				name: '[Z2] Trẻ có thể đặt các vật thuộc nhiều hình dạng vào hộp hình dạng',
				selected: true,
				sub_item_count: 0,
			},
			{
				id: 13,
				name: '[Z6] Trẻ có thể chuyển đồ vật từ tay này qua tay kia',
				selected: true,
				sub_item_count: 0,
			},
		],
	},
	{
		id: 2,
		name: 'Vận động thô',
		item_count: 3,
		library_items: [
			{
				id: 21,
				name: '[Y1] Trẻ đi đúng tư thế',
				selected: true,
				sub_item_count: 0,
			},
			{
				id: 22,
				name: '[Y2] Trẻ sẽ có thể quỳ gối và tự đứng lên',
				selected: true,
				sub_item_count: 0,
			},
			{
				id: 23,
				name: '[Y13] Trẻ có thể ngồi xổm và đứng lên',
				selected: true,
				sub_item_count: 0,
			},
		],
	},
];

function parseBody(data: any) {
	if (!data) return null;
	if (typeof data === 'string') {
		try {
			return JSON.parse(data);
		} catch (e) {
			return null;
		}
	}
	return data;
}

export const TUTORIAL_VIRTUAL_LIB_ID = 'tutorial-lib-1';

export const TUTORIAL_VIRTUAL_ORG_LIBRARIES = [
	{
		id: TUTORIAL_VIRTUAL_LIB_ID,
		name: 'Thư viện 1',
		numbers_of_goal: 384,
		numbers_of_skill: 12,
	},
	{
		id: 'tutorial-lib-2',
		name: 'Thư viện nội bộ ABA',
		numbers_of_goal: 200,
		numbers_of_skill: 12,
	},
	{
		id: 'tutorial-lib-3',
		name: 'Thư viện ngôn ngữ',
		numbers_of_goal: 360,
		numbers_of_skill: 14,
	},
	{
		id: 'tutorial-lib-4',
		name: 'Thư viện vận động',
		numbers_of_goal: 160,
		numbers_of_skill: 8,
	},
	{
		id: 'tutorial-lib-5',
		name: 'Thư viện hành vi',
		numbers_of_goal: 90,
		numbers_of_skill: 10,
	},
	{
		id: 'tutorial-lib-6',
		name: 'Thư viện tự lập',
		numbers_of_goal: 70,
		numbers_of_skill: 14,
	},
];

export const TUTORIAL_VIRTUAL_LIBRARY_DETAIL = {
	id: TUTORIAL_VIRTUAL_LIB_ID,
	name: 'Thư viện 1',
	created_by_staff: { name: 'Luca' },
	last_updated_at: '2021-02-04',
};

function tutorialLibGoal(
	id: string,
	name: string,
	skillName: string,
	extra: Record<string, unknown> = {}
) {
	return {
		id,
		name,
		goal_name: name,
		is_goal: true,
		skill: { name: skillName },
		skill_id: 2,
		sub_item_count: 0,
		used: false,
		open: false,
		children: [],
		...extra,
	};
}

export const TUTORIAL_VIRTUAL_LIBRARY_FOLDERS = [
	{
		id: 'tutorial-folder-root',
		name: 'Thư viện 1',
		is_goal: false,
		is_completed: false,
		open: true,
		children: [
			{
				id: 'tutorial-folder-3',
				name: 'Thư mục 3',
				is_goal: false,
				is_completed: false,
				open: true,
				children: [
					tutorialLibGoal(
						'tutorial-goal-1',
						'Củng cố đứng 1 chân 3-5s',
						'Vận động thô'
					),
					{
						...tutorialLibGoal(
							'tutorial-goal-2',
							'Củng cố đi 1 chân không trợ giúp',
							'Vận động tinh',
							{
								sub_item_count: 3,
								open: true,
							}
						),
						children: [
							tutorialLibGoal(
								'tutorial-goal-2-1',
								'Củng cố đứng 1 chân 3-5s',
								'Vận động thô'
							),
							tutorialLibGoal(
								'tutorial-goal-2-2',
								'Củng cố đứng 1 chân 3-5s',
								'Vận động thô'
							),
							tutorialLibGoal(
								'tutorial-goal-2-3',
								'Củng cố đứng 1 chân 3-5s',
								'Vận động thô'
							),
						],
					},
				],
			},
			{
				id: 'tutorial-folder-1',
				name: 'Thư mục 1',
				is_goal: false,
				is_completed: false,
				open: true,
				children: [
					tutorialLibGoal(
						'tutorial-goal-3',
						'Củng cố đứng 1 chân 3-5s',
						'Vận động thô'
					),
					{
						...tutorialLibGoal(
							'tutorial-goal-4',
							'Củng cố đi 1 chân không trợ giúp',
							'Vận động tinh',
							{
								sub_item_count: 3,
								open: true,
							}
						),
						children: [
							tutorialLibGoal(
								'tutorial-goal-4-1',
								'Củng cố đứng 1 chân 3-5s',
								'Vận động thô'
							),
							tutorialLibGoal(
								'tutorial-goal-4-2',
								'Củng cố đứng 1 chân 3-5s',
								'Vận động thô'
							),
							tutorialLibGoal(
								'tutorial-goal-4-3',
								'Củng cố đứng 1 chân 3-5s',
								'Vận động thô'
							),
						],
					},
				],
			},
		],
	},
];

export const TUTORIAL_VIRTUAL_BANK_STATS = {
	total_skill_count: 4,
	total_goal_count: 8,
	total_group_count: 2,
};

export const TUTORIAL_VIRTUAL_BANK_GROUPS = [
	{
		id: 'tutorial-group-1',
		name: 'Tên nhóm',
		created_by_staff: { name: 'Thanh Thảo' },
		created_at: '2022-12-23T10:00:00',
		goals_group_by_skill: [
			{
				id: 4,
				skill: { id: 4, name: 'Hành vi và giác quan' },
				goals: [
					{
						id: 101,
						goal_id: 101,
						name: 'Củng cố đứng 1 chân 3-5s',
						goal_name: 'Củng cố đứng 1 chân 3-5s',
						state: 'library',
						updated_at: '2021-02-04',
						created_by_staff: { name: 'Thu Huyền' },
						skill: { name: 'Hành vi và giác quan' },
					},
					{
						id: 102,
						goal_id: 102,
						name: '[A19] Tự hỏi lòng khi mình làm xong một việc',
						goal_name:
							'[A19] Tự hỏi lòng khi mình làm xong một việc',
						state: 'library',
						updated_at: '2021-02-04',
						created_by_staff: { name: 'Thu Huyền' },
						skill: { name: 'Hành vi và giác quan' },
					},
					{
						id: 103,
						goal_id: 103,
						name: 'Củng cố đứng 1 chân 3-5s',
						goal_name: 'Củng cố đứng 1 chân 3-5s',
						state: 'library',
						updated_at: '2021-02-04',
						created_by_staff: { name: 'Thu Huyền' },
						skill: { name: 'Vận động thô' },
					},
				],
			},
		],
	},
];

export const TUTORIAL_VIRTUAL_ASSISTANCE_LEVELS = [
	{ id: 1, name: 'Độc lập', order: 1 },
	{ id: 2, name: 'Gợi ý bằng lời', order: 2 },
	{ id: 3, name: 'Hỗ trợ một phần', order: 3 },
];

export function isTutorialVirtualHttpRequest(config: any) {
	const url = String(config?.url || '');
	const method = String(config?.method || 'get').toLowerCase();
	const isOrgLibraryRead =
		method === 'get' &&
		!url.includes('tutorial-lib') &&
		(url.includes('/goal_libraries') ||
			url.includes('all_library_items') ||
			url.includes('/library_items/search'));
	if (isOrgLibraryRead) return false;

	if (url.includes(TUTORIAL_VIRTUAL_STUDENT_ID)) return true;
	if (url.includes('tutorial-lib')) return true;
	if (isTutorialVirtualStudent(config?.params?.student_id)) return true;
	const body = parseBody(config?.data);
	if (isTutorialVirtualStudent(body?.student_id)) return true;
	return false;
}

export function mockTutorialVirtualAxiosResponse(config: any) {
	const url = String(config?.url || '');
	const method = String(config?.method || 'get').toLowerCase();
	let payload: any = { data: [] };

	if (
		/students\/tutorial-virtual\/?$/.test(url) &&
		method === 'get'
	) {
		payload = { data: TUTORIAL_VIRTUAL_STUDENT };
	} else if (url.includes('/plans/active')) {
		payload = {
			data: TUTORIAL_VIRTUAL_PLAN,
			stats: TUTORIAL_VIRTUAL_PLAN_STATS,
			skills: {
				continued: [
					{
						skill: { name: 'Hành vi và giác quan' },
						goals: [
							{
								id: 201,
								goal_id: 201,
								name: 'Củng cố đứng 1 chân 3-5s',
								goal_name: 'Củng cố đứng 1 chân 3-5s',
								state: 'stopped',
								learned_days: 10,
							},
							{
								id: 202,
								goal_id: 202,
								name: 'Củng cố đứng 1 chân 3-5s',
								goal_name: 'Củng cố đứng 1 chân 3-5s',
								state: 'stopped',
								learned_days: 10,
							},
						],
					},
				],
			},
		};
	} else if (url.includes('groups_with_goals_of_pending_plan')) {
		payload = { data: [], plan: null };
	} else if (url.includes('groups_with_goals/library')) {
		payload = {
			data: JSON.parse(JSON.stringify(TUTORIAL_VIRTUAL_BANK_GROUPS)),
			stats: { ...TUTORIAL_VIRTUAL_BANK_STATS },
		};
	} else if (
		url.includes('/goals/library') &&
		method === 'get' &&
		!url.includes('list_goals')
	) {
		payload = {
			data: {
				skills: JSON.parse(
					JSON.stringify(
						TUTORIAL_VIRTUAL_BANK_GROUPS[0].goals_group_by_skill
					)
				),
			},
			stats: {
				skills_count: TUTORIAL_VIRTUAL_BANK_STATS.total_skill_count,
				goals_count: TUTORIAL_VIRTUAL_BANK_STATS.total_goal_count,
			},
		};
	} else if (url.includes('all_library_items')) {
		payload = {
			data: JSON.parse(JSON.stringify(TUTORIAL_VIRTUAL_LIBRARY_FOLDERS)),
		};
	} else if (url.includes('goal_libraries/tutorial-lib')) {
		payload = { data: { ...TUTORIAL_VIRTUAL_LIBRARY_DETAIL } };
	} else if (url.includes('suggested_from_goal_library')) {
		payload = { grouped_items: [], item_count: 0, skill_count: 0 };
	} else if (
		url.includes('create_goals_from_library_items') ||
		url.includes('create_from_library') ||
		url.includes('create_all_from_library') ||
		(url.includes('goals/library') && method === 'post') ||
		(url.includes('/goals') && method === 'post') ||
		method === 'put' ||
		method === 'patch' ||
		method === 'delete'
	) {
		payload = { data: { id: 'tutorial-goal' } };
	} else if (url.includes('groups_with_goals')) {
		payload = {
			data: [],
			plan: TUTORIAL_VIRTUAL_PLAN,
			stats: TUTORIAL_VIRTUAL_PLAN_STATS,
			has_pending_plan: false,
		};
	} else if (url.includes('two_layers_goals_library')) {
		payload = {
			data: { skills: [] },
			stats: {},
		};
	} else if (url.includes('with_skills')) {
		payload = { data: { skills: [] } };
	} else if (url.includes('goals/all')) {
		payload = { data: [] };
	} else if (
		/\/plans\/[^/?]+/.test(url) &&
		method === 'get' &&
		!url.includes('/plans/active') &&
		!url.includes('/plans/scheduled')
	) {
		payload = {
			data: TUTORIAL_VIRTUAL_PLAN,
			stats: { ...TUTORIAL_VIRTUAL_PLAN_STATS },
		};
	} else if (url.includes('/plans') && method === 'get') {
		payload = { data: { plans: [] } };
	} else if (url.includes('list_skills_with_age_range')) {
		payload = {
			data: TUTORIAL_VIRTUAL_SKILLS.map((skill) => ({ ...skill })),
			goal_libraries: { ...TUTORIAL_VIRTUAL_GOAL_LIBRARY },
		};
	} else if (url.includes('generate_by_age_from_goal_libraries')) {
		payload = {
			data: JSON.parse(JSON.stringify(TUTORIAL_VIRTUAL_LIBRARY_CREATE)),
		};
	} else if (url.includes('create_from_suggestion')) {
		payload = { data: { id: 'tutorial-group' } };
	} else if (url.includes('with_age_range')) {
		payload = { data: TUTORIAL_VIRTUAL_LIBRARIES };
	} else {
		payload = { data: [], stats: {} };
	}

	return {
		data: payload,
		status: 200,
		statusText: 'OK',
		headers: {},
		config,
	};
}
